// document.addEventListener('DOMContentLoaded', () => {
//   const buttons = document.querySelectorAll('.shop-the-look__dot');
//   const isMobile = window.matchMedia('(max-width: 749px)').matches;

//   function closeAll() {
//     document.querySelectorAll('openable-element[open]').forEach(p => {
//       p.removeAttribute('open');
//     });
//     buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
//   }

//   buttons.forEach(button => {
//     const popupId = button.getAttribute('aria-controls');
//     const popup = document.querySelector(`openable-element#${popupId}`);
//     if (!popup) return;

//     const wrapper = button.closest('.shop-the-look__product-wrapper');
//     const imageWrapper = wrapper?.closest('.shop-the-look__image-wrapper');

//     const openPopup = () => {
//       closeAll();

//       if (!isMobile && wrapper && imageWrapper) {
//         // DESKTOP positioning
//         imageWrapper.appendChild(popup);

//         const topPercent = parseFloat(wrapper.dataset.top);
//         const leftPercent = parseFloat(wrapper.dataset.left);
//         const buttonHeightPercent =
//           (button.offsetHeight / imageWrapper.offsetHeight) * 100;

//         popup.style.top = `${topPercent + buttonHeightPercent + 2}%`;
//         popup.style.left = `${leftPercent}%`;
//         popup.style.transform = 'translateX(-50%)';
//       }

//       popup.setAttribute('open', '');
//       button.setAttribute('aria-expanded', 'true');
//     };

//     // DESKTOP hover behavior
//     if (!isMobile) {
//       button.addEventListener('mouseenter', openPopup);

//       button.addEventListener('mouseleave', () => {
//         setTimeout(() => {
//           if (!popup.matches(':hover')) {
//             popup.removeAttribute('open');
//             button.setAttribute('aria-expanded', 'false');
//           }
//         }, 120);
//       });

//       popup.addEventListener('mouseleave', () => {
//         popup.removeAttribute('open');
//         button.setAttribute('aria-expanded', 'false');
//       });
//     }

//     // CLICK behavior (toggle on mobile)
//     button.addEventListener('click', (e) => {
//       e.preventDefault();

//       if (isMobile) {
//         if (popup.hasAttribute('open')) {
          
//           popup.removeAttribute('open');
//           button.setAttribute('aria-expanded', 'false');
//         } else {
          
//           openPopup();
//         }
//       } else {
//         openPopup();
//       }
//     });
//   });
// });



document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.shop-the-look__dot');
const html = document.documentElement;
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  function closeAll() {
    document.querySelectorAll('openable-element[open], quick-buy-popover[open]').forEach(el => {
      el.removeAttribute('open');
    });

    buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
  }

  buttons.forEach(button => {
    const popupId = button.getAttribute('aria-controls');

    const desktopPopup = document.querySelector(
      `openable-element#${popupId}`
    );

    const mobilePopup = document.querySelector(
      `quick-buy-popover#${popupId}`
    );

    const wrapper = button.closest('.shop-the-look__product-wrapper');
    const imageWrapper = wrapper?.closest('.shop-the-look__image-wrapper');

    /* ---------- DESKTOP OPEN ---------- */
    const openDesktopPopup = () => {
      if (!desktopPopup || !wrapper || !imageWrapper) return;

      closeAll();

      imageWrapper.appendChild(desktopPopup);

      const topPercent = parseFloat(wrapper.dataset.top);
      const leftPercent = parseFloat(wrapper.dataset.left);
      const buttonHeightPercent =
        (button.offsetHeight / imageWrapper.offsetHeight) * 100;

      desktopPopup.style.top = `${topPercent + buttonHeightPercent + 2}%`;
      desktopPopup.style.left = `${leftPercent}%`;
      desktopPopup.style.transform = 'translateX(-50%)';

      desktopPopup.setAttribute('open', '');
      button.setAttribute('aria-expanded', 'true');
    };

    /* ---------- MOBILE OPEN ---------- */
    const openMobilePopup = () => {
      if (!mobilePopup) return;

      closeAll();
      mobilePopup.setAttribute('open', '');
      button.setAttribute('aria-expanded', 'true');
      html.classList.add('lock-mobile');
    };

    /* ---------- DESKTOP HOVER ---------- */
    if (!isMobile()) {
      button.addEventListener('mouseenter', openDesktopPopup);

      button.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (desktopPopup && !desktopPopup.matches(':hover')) {
            desktopPopup.removeAttribute('open');
            button.setAttribute('aria-expanded', 'false');
          }
        }, 120);
      });

      desktopPopup?.addEventListener('mouseleave', () => {
        desktopPopup.removeAttribute('open');
        button.setAttribute('aria-expanded', 'false');
      });
    }

    /* ---------- CLICK ---------- */
    button.addEventListener('click', (e) => {
      e.preventDefault();

      if (isMobile()) {
        if (mobilePopup?.hasAttribute('open')) {
          mobilePopup.removeAttribute('open');
          button.setAttribute('aria-expanded', 'false');
           html.classList.remove('lock-mobile');
        } else {
          openMobilePopup();
        }
      } else {
        openDesktopPopup();
      }
    });

    /* ---------- MOBILE CLOSE BUTTON ---------- */
    const closeBtn = mobilePopup?.querySelector('[data-action="close"]');

    closeBtn?.addEventListener('click', () => {
      mobilePopup.removeAttribute('open');
      button.setAttribute('aria-expanded', 'false');
       html.classList.remove('lock-mobile');
    });

    /* ---------- OVERLAY CLICK CLOSE ---------- */
    const overlay = mobilePopup?.querySelector('.popover__overlay');
    overlay?.addEventListener('click', () => {
      mobilePopup.removeAttribute('open');
      button.setAttribute('aria-expanded', 'false');
       html.classList.remove('lock-mobile');
    });
  });
});
